// Colocated strings for IssuesGrid (SKILL.md rule 11, PLATFORM.md §6 decision 15).
// Consumed by ../setup.js as `useComponentI18n(messages)` from `@rdrive/i18n`, i.e. a LOCAL
// composer with the warn flags off: these keys resolve here and never touch the app's bundle.
//
// Lifted from what issue-analysis rendered when the grid moved out of the app (2026-10-12): each
// value is the one its root bundle resolved — `src/locales/<locale>.json` over `@rdrive/vocabulary`
// — in all 10 locales. Six are rdrive vocabulary words (`id`, `location`, `type`, `category`,
// `item`, `assignedTo`; this package never imports the vocabulary — these copies shadow it).
// `photo`, `issueDescription`, `responsibleParty` and `dueBy` stay in the app's bundle too (its
// report and Analysis page render them); the other ten left it with the move. `close` (the app's
// `settings.close`) left THIS folder at AM_ABSORPTION_PLAN step C5a with the photo dialog, for
// the sibling ItemPhotoDialog's messages (same values); `photo` is in both — here it is the
// column header, there the dialog's title.
//
// Not a key, and still an English literal in the component: the 'Unassigned' fallback of the
// status column's team (translation debt, as before the move).
import de from './de.json';
import en from './en.json';
import fr from './fr.json';
import it from './it.json';
import nl from './nl.json';
import pl from './pl.json';
import ptBR from './pt-BR.json';
import th from './th.json';
import vi from './vi.json';
import zhHans from './zh-Hans.json';
import zhHant from './zh-Hant.json';

export default {
  de,
  en,
  fr,
  it,
  nl,
  pl,
  'pt-BR': ptBR,
  th,
  vi,
  'zh-Hans': zhHans,
  'zh-Hant': zhHant,
};
